import { Controller } from "@hotwired/stimulus"

// Setzt eine geparste Kompetenz per Haekchen aufs Profil (POST create).
// Antwort ist ein Turbo-Stream, der den Zonen-Container ersetzt -> die Zeile
// wandert von "Weitere" nach "Auf dem Profil". Das Entfernen (abwaehlen) laeuft
// in Zone 1 ueber den Papierkorb (destroy) im inline-Partial.
export default class extends Controller {
  static values = {
    createUrl: String,
    applicantCompetencyId: Number,
  }

  async add(event) {
    const checkbox = event.target
    if (!checkbox.checked) return
    const url = this.createUrlValue
    if (!url) return
    checkbox.disabled = true
    try {
      const body = new URLSearchParams()
      body.append("profile_competency[applicant_competency_id]", this.applicantCompetencyIdValue)
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "text/vnd.turbo-stream.html, text/html",
        },
        credentials: "same-origin",
        body,
      })
      if (response.ok) {
        const html = await response.text()
        if (html.includes("turbo-stream")) {
          Turbo.renderStreamMessage(html)
        }
      } else {
        checkbox.checked = false
        checkbox.disabled = false
      }
    } catch (e) {
      console.error("Kompetenz zuwählen fehlgeschlagen:", e)
      checkbox.checked = false
      checkbox.disabled = false
    }
  }
}
